export default __webpack_public_path__ + "static/favicon-ebc8ee99b6caf98dd50db652f3a6605f.ico";